import { FetchAPI } from 'utils/fetch/fetch-api';
import { AmountForPaidDTO } from 'utils/types/finance';
import { RequestQuery } from 'utils/types/request-types';

class FinanceService extends FetchAPI {
	getTransactions = (query: RequestQuery): Promise<AmountForPaidDTO> => this.get<AmountForPaidDTO>(query);
}

export { FinanceService };
